import React from 'react';
import FormSteps from '../FormSteps';
import FormField from '../../../../FormField';
/**
 * @param {Object} formik
 * @param {Function} goToNextStep
 */
const BrandNameStep = ({ formik, goToNextStep, currentStep = 0, totalSteps = 1 }) => {
    const handleNext = () => {
        goToNextStep(['firstName', 'lastName']);
    };

    return (
        <div style={{ position: 'relative' }}>
            <FormSteps
                header="What is your name?"
                description="Let us know what to call you."
                nextButton={handleNext}
            >
                <div className="field mb-4">
                    <div className="field-body">
                        <FormField
                            additionalInputClasses="has-background-white"
                            name="firstName"
                            placeholder="First Name"
                            onChange={formik.handleChange}
                            value={formik.values.firstName}
                            onBlur={formik.handleBlur}
                        />
                    </div>
                </div>

                <div className="field mb-6">
                    <div className="field-body">
                        <FormField
                            additionalInputClasses="has-background-white"
                            name="lastName"
                            placeholder="Last Name"
                            onChange={formik.handleChange}
                            value={formik.values.lastName}
                            onBlur={formik.handleBlur}
                        />
                    </div>
                </div>
            </FormSteps>
        </div>
    );
};

export default BrandNameStep;